























import Vue from 'vue';
import axios from 'axios';
import CoAlert from '../../components/Molecules/co-alert/CoAlert.vue';
import i18n from 'vue-i18n';

const debounce = require('debounce');

export default {
    i18n: {
        messages: {
            en: {
                chatnotselected: 'Select a chat to start messaging',
            },
            de: {
                chatnotselected: 'Wähle einen Chat zum Schreiben',
            },
        },
    },
    name: 'NewMessage',
    components: {
        CoAlert,
    },
    data() {
        return {
            creatingThread: true,
            projects: [],
            usersearch: '',
            users: [],
            searchingUsers: false,
        };
    },
    mounted() {},
    methods: {
        usersSearchResult: debounce(function (e) {
            this.searchingUsers = true;
            axios({
                method: 'GET',
                url: `/search/user/${this.usersearch}`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        this.users = [];
                        response.data.forEach(function (entry) {
                            if (this.$store.state.me.ID == entry.ID) return;

                            this.users.push(entry);
                        }, this);
                        this.searchingUsers = false;
                    }
                })
                .catch((error) => {
                    this.searchingUsers = false;
                });
        }, 200),

        createThread(user) {
            const thread = {
                Participants: [this.$store.state.me.ID, user.ID],
            };
            axios({
                method: 'POST',
                url: '/chat/t',
                withCredentials: true,
                data: JSON.stringify(thread),
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {})
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
